import type { ReactNode } from 'react';
import React, { useEffect } from 'react';

import { useSelector } from 'react-redux';
import type { RootState } from '../store/store';
import { jwtDecode } from 'jwt-decode';
import { useNavigate } from 'react-router-dom';
interface ProtectedRouteProps {
  children: ReactNode;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const { tableauToken,token } = useSelector((state: RootState) => state.auth);
  const navigate = useNavigate();

  useEffect(() => {
        if (token != null) {
            const dJwt = jwtDecode(token);
            console.log(dJwt);
            const current_time = Date.now() / 1000
            const exp_time = (dJwt.exp != null) ? dJwt.exp : current_time
            if (current_time > exp_time) {
              navigate('/')
            } 
        } else {
          navigate('/')
      }
        

}, [tableauToken, navigate])

  return <>{children}</>;
};

export default ProtectedRoute;


